// src/lib/auth/SuperadminRoute.jsx
// Route guard for platform-superadmin-only pages (New Brand Setup, Brand Dashboard).
// Superadmin is an Auth custom claim (`superadmin:true`), NOT a Firestore role — so this does
// NOT use ProtectedRoute/allowedRoles (under which the `admin` role sees everything). rules.v2
// is the real authority (request.auth.token.superadmin); this guard is just UX so non-superadmins
// don't see the pages, and the callables (provisionBrand/activateBrand) re-check server-side.
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../auth';

export default function SuperadminRoute({ children }) {
  const location = useLocation();
  const { user, loading, claims, isSuperadmin } = useAuth();

  const spinner = (
    <Box sx={{ minHeight: '50vh', display: 'grid', placeItems: 'center' }}>
      <CircularProgress />
    </Box>
  );

  // 1) Wait for Firebase auth to resolve.
  if (loading) return spinner;

  // 2) Not signed in.
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  // 3) Signed in but the ID-token claims haven't been read yet — wait (avoids a flash).
  if (claims === null) return spinner;

  // 4) Claims resolved: gate on the superadmin claim.
  if (!isSuperadmin) return <Navigate to="/not-authorized" replace />;

  return children;
}
